import { _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from './CanBlockBack.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { lastOrNull1aq5oz189qoe1 as lastOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { dismissTopDialog36m1xp4el7vem as dismissTopDialog } from '../views/ViewContextExtensions.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  substringAfter35b3qhto7hchb as substringAfter,
  substringAfter1hku067gwr5ve as substringAfter_0,
  removePrefix279df90bhrqqg as removePrefix,
  split3d3yeauc4rm2n as split,
  isBlank1dvkhjjvox3p0 as isBlank,
  trimStart1mkod6gyztuyy as trimStart,
  substringBefore3n7kj60w69hju as substringBefore,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { UrlLikePath1l4lcedbwd0yq as UrlLikePath } from './Routes.mjs';
import { Default_getInstance27jodt8hd1bac as Default_getInstance } from '../debugger.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_basePath() {
  _init_properties_Navigator_js_kt__1lm31c();
  return basePath;
}
var basePath;
function askForConfirmNavigateAway(_this__u8e3s4) {
  _init_properties_Navigator_js_kt__1lm31c();
  return window.confirm('Are you sure you want to leave this page?\nChanges will not be saved.');
}
function bindToPlatform(_this__u8e3s4, context) {
  _init_properties_Navigator_js_kt__1lm31c();
  var beforeUnload = (event) => {
    var tmp0_safe_receiver = _ReactiveState___get_raw__impl__92ipya(_this__u8e3s4.currentPage_1.get_state_wc71uu_k$());
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = isInterface(tmp0_safe_receiver, CanBlockBack()) ? tmp0_safe_receiver : null;
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.onNavigateAwayAttempt_vrrtsh_k$();
    var canLeave = tmp2_elvis_lhs == null ? true : tmp2_elvis_lhs;
    var tmp_0;
    if (!canLeave) {
      event.preventDefault();
      // Inline function 'kotlin.js.asDynamic' call
      tmp_0 = event.returnValue = '';
    }
    return Unit_instance;
  };
  window.addEventListener('beforeunload', beforeUnload);
  var log = null;
  var lastStackForPath = MaxSizeMap().new_com_lightningkite_kiteui_navigation_MaxSizeMap_ngzdo4_k$(50);
  var initBar = urlLike(window.location);
  bindToPlatform$guessAndImplementFromUrlBar(_this__u8e3s4, lastStackForPath, initBar);
  var suppressNav = {_v: false};
  var tmp = window;
  tmp.addEventListener('popstate', (event) => {
    var tmp;
    if (suppressNav._v) {
      return Unit_instance;
    }
    if (!(event instanceof PopStateEvent))
      THROW_CCE();
    var tmp_0;
    if (dismissTopDialog(context)) {
      var tmp_1 = _this__u8e3s4.get_routes_j3zccz_k$();
      var tmp0_elvis_lhs = lastOrNull(_this__u8e3s4.stack_1.get_value_j01efc_k$());
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      var tmp1_safe_receiver = tmp_1.render_y0xm4o_k$(tmp_2);
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.urlLikePath_1;
      var tmp_3;
      if (tmp2_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_3 = tmp2_elvis_lhs;
      }
      var currentUrl = tmp_3;
      window.history.pushState(null, '', get_basePath() + currentUrl.render_fgfjvu_k$());
      return Unit_instance;
    }
    var tmp_4;
    try {
      suppressNav._v = true;
      bindToPlatform$guessAndImplementFromUrlBar(_this__u8e3s4, lastStackForPath, urlLike(window.location));
      tmp_4 = Unit_instance;
    }finally {
      suppressNav._v = false;
    }
    return Unit_instance;
  });
  var lastStack = {_v: _this__u8e3s4.stack_1.get_value_j01efc_k$()};
  var tmp_0 = get_AppScope();
  reactive(tmp_0, VOID, ($this$reactive) => {
    var s = $this$reactive.invoke_r7m7el_k$(_this__u8e3s4.stack_1);
    var tmp;
    if (suppressNav._v) {
      return Unit_instance;
    }
    var tmp_0;
    try {
      suppressNav._v = true;
      var tmp_1;
      if (!equals(lastOrNull(s), lastOrNull(lastStack._v))) {
        var tmp0_elvis_lhs = lastOrNull(s);
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var new_0 = tmp_2;
        var tmp1_safe_receiver = _this__u8e3s4.get_routes_j3zccz_k$().render_y0xm4o_k$(new_0);
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.urlLikePath_1;
        if (tmp2_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver = log;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.log_iyb52q_k$(["pushState '" + tmp2_safe_receiver.render_fgfjvu_k$() + "'..."]);
          }
          window.history.pushState(null, '', get_basePath() + tmp2_safe_receiver.render_fgfjvu_k$());
        }
        tmp_1 = Unit_instance;
      }
      tmp_0 = tmp_1;
    }finally {
      suppressNav._v = false;
    }
    return Unit_instance;
  });
  var tmp_1 = get_AppScope();
  reactive(tmp_1, VOID, ($this$reactive) => {
    var s = $this$reactive.invoke_r7m7el_k$(_this__u8e3s4.stack_1);
    var tmp0_safe_receiver = lastOrNull(s);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = _this__u8e3s4.get_routes_j3zccz_k$().render_y0xm4o_k$(tmp0_safe_receiver);
    }
    var tmp1_safe_receiver = tmp;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      $l$block: {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = tmp1_safe_receiver.listenables_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          $this$reactive.rerunOn_6homfr_k$(element);
        }
        if (suppressNav._v) {
          break $l$block;
        }
        var tmp0_safe_receiver_0 = log;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          tmp0_safe_receiver_0.log_iyb52q_k$(['Replacing state as index ' + get_lastIndex(s) + " with '" + tmp1_safe_receiver.urlLikePath_1.render_fgfjvu_k$() + "'"]);
        }
        // Inline function 'kotlin.let' call
        var it = tmp1_safe_receiver.urlLikePath_1;
        window.history.replaceState(get_lastIndex(s), '', get_basePath() + it.render_fgfjvu_k$());
        var tmp0 = lastStackForPath;
        // Inline function 'kotlin.collections.set' call
        var key = tmp1_safe_receiver.urlLikePath_1;
        tmp0.put_4fpzoq_k$(key, s);
      }
      tmp_0 = Unit_instance;
    }
    return tmp_0;
  });
  var tmp_2 = get_AppScope();
  reactive(tmp_2, VOID, ($this$reactive) => {
    var tmp = document;
    var tmp0_safe_receiver = lastOrNull($this$reactive.invoke_r7m7el_k$(_this__u8e3s4.stack_1));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_title_iz32un_k$();
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : $this$reactive.invoke_r7m7el_k$(tmp1_safe_receiver);
    tmp.title = tmp2_elvis_lhs == null ? 'App' : tmp2_elvis_lhs;
    return Unit_instance;
  });
}
var MaxSizeMapClass;
function MaxSizeMap() {
  if (MaxSizeMapClass === VOID) {
    class $ extends LinkedHashMap() {
      constructor(maxSize) {
        return new.target.new_com_lightningkite_kiteui_navigation_MaxSizeMap_ngzdo4_k$(maxSize);
      }
      static new_com_lightningkite_kiteui_navigation_MaxSizeMap_ngzdo4_k$(maxSize) {
        var $this = this.new_kotlin_collections_LinkedHashMap_ga0any_k$();
        $this.maxSize_1 = maxSize;
        return $this;
      }
      get_h31hzz_k$(key) {
        var tmp0_elvis_lhs = super.remove_gppy8k_k$(key);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var value = tmp;
        super.put_4fpzoq_k$(key, value);
        return value;
      }
      get_wei43m_k$(key) {
        if (!!(key == null))
          return null;
        return this.get_h31hzz_k$(!(key == null) ? key : THROW_CCE());
      }
      put_ngjsat_k$(key, value) {
        var old = super.remove_gppy8k_k$(key);
        var result = super.put_4fpzoq_k$(key, value);
        while (this.get_size_woubt6_k$() > this.maxSize_1) {
          var oldest = this.get_keys_wop4xp_k$().iterator_jk1svi_k$().next_20eer_k$();
          super.remove_gppy8k_k$(oldest);
        }
        return old == null ? result : old;
      }
      put_4fpzoq_k$(key, value) {
        return this.put_ngjsat_k$(!(key == null) ? key : THROW_CCE(), value);
      }
    }
    initMetadataForClass($, 'MaxSizeMap');
    MaxSizeMapClass = $;
  }
  return MaxSizeMapClass;
}
function urlLike(_this__u8e3s4) {
  _init_properties_Navigator_js_kt__1lm31c();
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = split(removePrefix(_this__u8e3s4.pathname, '/' + substringAfter_0(substringAfter(get_basePath(), '://'), _Char___init__impl__6a9atx(47))), charArrayOf([_Char___init__impl__6a9atx(47)]));
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(element)) {
      destination.add_utx5q5_k$(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s_0.next_20eer_k$();
    var tmp$ret$6 = decodeURIComponent(item);
    destination_0.add_utx5q5_k$(tmp$ret$6);
  }
  var tmp = destination_0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = split(trimStart(_this__u8e3s4.search, charArrayOf([_Char___init__impl__6a9atx(63)])), charArrayOf([_Char___init__impl__6a9atx(38)]));
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_1 = tmp0_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s_1.next_20eer_k$();
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(element_0)) {
      destination_1.add_utx5q5_k$(element_0);
    }
  }
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_1, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_2 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
  var _iterator__ex2g4s_2 = destination_1.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
    var element_1 = _iterator__ex2g4s_2.next_20eer_k$();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(decodeURIComponent(substringBefore(element_1, _Char___init__impl__6a9atx(61))), decodeURIComponent(substringAfter_0(element_1, _Char___init__impl__6a9atx(61))));
    destination_2.put_4fpzoq_k$(pair.first_1, pair.second_1);
  }
  return new (UrlLikePath())(tmp, destination_2);
}
function bindToPlatform$guessAndImplementFromUrlBar($this_bindToPlatform, lastStackForPath, urlLikePath) {
  // Inline function 'kotlin.collections.getOrPut' call
  var value = lastStackForPath.get_wei43m_k$(urlLikePath);
  var tmp;
  if (value == null) {
    var answer = listOf($this_bindToPlatform.get_routes_j3zccz_k$().parseOrFallback_nkiumm_k$(urlLikePath));
    lastStackForPath.put_4fpzoq_k$(urlLikePath, answer);
    tmp = answer;
  } else {
    tmp = value;
  }
  var tmp$ret$0 = tmp;
  $this_bindToPlatform.stack_1.set_value_v1vabv_k$(tmp$ret$0);
}
var properties_initialized_Navigator_js_kt_v5tcse;
function _init_properties_Navigator_js_kt__1lm31c() {
  if (!properties_initialized_Navigator_js_kt_v5tcse) {
    properties_initialized_Navigator_js_kt_v5tcse = true;
    var tmp = document.getElementById('baseUrlLocation');
    var tmp0_safe_receiver = tmp instanceof HTMLScriptElement ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.innerText;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = JSON.parse(tmp1_safe_receiver).baseUrl;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.takeIf' call
      var this_0 = document.baseURI;
      var tmp_2;
      if (!(document.getElementsByTagName('base').length === 0)) {
        tmp_2 = this_0;
      } else {
        tmp_2 = null;
      }
      tmp_1 = tmp_2;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_1;
    // Inline function 'kotlin.also' call
    var this_1 = tmp3_elvis_lhs == null ? '/' : tmp3_elvis_lhs;
    Default_getInstance().info_59mt0k_k$(['Base path is ' + this_1]);
    basePath = this_1;
  }
}
//region block: exports
export {
  askForConfirmNavigateAway as askForConfirmNavigateAway3jun0podjheub,
  get_basePath as get_basePath37oh0bkfrtwru,
  bindToPlatform as bindToPlatform1wt9rhq76dpm9,
};
//endregion

//# sourceMappingURL=Navigator.js.mjs.map
